'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STUBBED_CHANNEL = exports.STUBBED_CHANNEL = 'STUBBED_CHANNEL';


//////////////////
// WEBPACK FOOTER
// ./js/threads/constants/stubbedChannel.js
// module id = 24
// module chunks = 2 3